module.exports = __webpack_public_path__ + "img/360.0fa0eba8.svg";